import React, { useEffect } from 'react';
import gameSounds from '../utils/sounds';
import '../styles/FactCard.css';

const FactCard = ({ fact, onDismiss }) => {
  useEffect(() => {
    // Play slide-in sound when fact card appears
    gameSounds.playSlideIn();
    
    const handleKeyPress = () => {
      onDismiss();
    };

    const handleClick = () => {
      onDismiss();
    };

    window.addEventListener('keydown', handleKeyPress);
    window.addEventListener('click', handleClick);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
      window.removeEventListener('click', handleClick);
    };
  }, [onDismiss]);

  return (
    <div className="fact-card-overlay">
      <div className="fact-card" style={{ borderColor: fact.color }}>
        <div className="fact-level" style={{ color: fact.color }}>
          {fact.level}
        </div>
        <h2 className="fact-title" style={{ color: fact.color }}>
          {fact.title}
        </h2>
        <div className="fact-body">
          {fact.body}
        </div>
        {fact.powerUp && (
          <div className="fact-powerup" style={{ color: fact.color }}>
            ⚡ Power-up unlocked: {fact.powerUp}
          </div>
        )}
        <div className="fact-dismiss">
          tap or press any key to continue
        </div>
      </div>
    </div>
  );
};

export default FactCard;
